import React, { useEffect, useMemo } from 'react';
import {
  forEach, get, isEmpty, join, keys, sortBy,
} from 'lodash';
import { VOUCHER_STATUS } from '../components/redeemCode/Item';
import RedeemCode from '../components/redeemCode/RedeemCode';
import { useRedeemInfoStoreContext } from '../contexts/redeemCode';
import { OPTION_KEY_STRING_MAP } from '../../menu/constants';

export default () => {
  const {
    getRedeemInfo,
    isInited,
    isLoading,
    productsDict,
    redeemCode,
    sendRedeemCode,
    vouchers,
  } = useRedeemInfoStoreContext();
  const { code, expireTime } = redeemCode || {};

  useEffect(() => {
    getRedeemInfo();
  }, [getRedeemInfo]);

  const data = useMemo(() => {
    const result = [];

    vouchers.forEach((voucher) => {
      const {
        productIds, isExpired, isUsed, isRevoked, productOptions,
      } = voucher || {};
      const providerNames = [];
      const productNames = [];
      let status = VOUCHER_STATUS.REDEEMABLE;

      (productIds || []).forEach((productId) => {
        const { name, provider } = productsDict[productId] || [];
        const optionStrings = [];

        forEach(sortBy(keys(productOptions)), (key) => {
          const optionStringMap = get(OPTION_KEY_STRING_MAP, key);

          if (isEmpty(optionStringMap)) return;

          const optionString = get(optionStringMap, productOptions[key]);

          if (isEmpty(optionString)) return;

          optionStrings.push(optionString);
        });

        const optionString = join(optionStrings, ',');

        const productName = `${name}${optionString ? `(${optionString})` : ''}`;

        productNames.push(productName);
        providerNames.push(provider);
      });

      if (isExpired) status = VOUCHER_STATUS.EXPIRED;
      if (isUsed) status = VOUCHER_STATUS.REDEEMED;
      if (isRevoked) status = VOUCHER_STATUS.REVOKED;

      const voucherResult = {
        ...voucher,
        productNames,
        providerNames,
        status,
      };

      if (status === VOUCHER_STATUS.REDEEMABLE) {
        result.unshift(voucherResult);
      } else {
        result.push(voucherResult);
      }
    });

    return result;
  }, [vouchers, productsDict]);

  return (
    <RedeemCode
      expireTime={expireTime}
      isInited={isInited}
      isLoading={isLoading}
      onSendRedeemCodeButtonClick={sendRedeemCode}
      redeemCode={code}
      vouchers={data}
    />
  );
};
